import React, { useState, useCallback, useRef } from 'react';
import PropTypes from 'prop-types';
import { isNumber } from 'lodash';
import {
  PILCROW_CHARACTER,
  PILCROW_REGEX,
  TEXT_LENGTH_LIMIT,
} from '../../../constants';

export default function OpenEnded({ question }) {
  const { minLength } = question;
  let { maxLength } = question;
  maxLength = isNumber(maxLength) ? maxLength : TEXT_LENGTH_LIMIT;
  const { getText } = Pollfish.ui;
  const { addInteraction } = Pollfish.event;
  const [value, setValue] = useState('');
  const inputRef = useRef(null);

  const onChange = useCallback(
    (event) => {
      addInteraction(event);
      setValue(event.target.value);
    },
    [addInteraction],
  );

  const onKeyUp = useCallback(
    (event) => {
      if (event.keyCode === 13) {
        setValue(value.replace(/\n+/g, ''));
        if (inputRef.current) {
          inputRef.current.blur();
        }
      } else if (event.key === PILCROW_CHARACTER) {
        setValue(value.replace(PILCROW_REGEX, ''));
      }
    },
    [value],
  );

  const onPaste = useCallback((event) => event.preventDefault(), []);

  const valueLength = value.length;
  const remaining = maxLength - valueLength;
  // we decided we don't want to show negative values on the remaining number
  const sanitisedRemaining = remaining >= 0 ? remaining : 0;
  const isZeroRemaining = sanitisedRemaining === 0;

  let className = 'input-text-note--valid';

  if (isNumber(minLength) && valueLength < minLength) {
    className = 'input-text-note--invalid';
  }

  if (isZeroRemaining) {
    className = 'input-text-note--invalid';
  }

  return (
    <div className="form-container">
      <textarea
        ref={inputRef}
        value={value}
        // eslint-disable-next-line jsx-a11y/no-autofocus
        autoFocus={Pollfish.helper.shouldAutofocus()}
        id="freeText"
        className="input-text"
        placeholder={getText('freeTextBox')}
        rows="3"
        maxLength={maxLength}
        onChange={onChange}
        onKeyUp={onKeyUp}
        onPaste={onPaste}
      ></textarea>
      <span className={`input-text-note ${className}`}>
        <span>{sanitisedRemaining}</span>
      </span>
    </div>
  );
}

OpenEnded.propTypes = {
  question: PropTypes.object.isRequired,
};
